import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';
import Notification from '@tds/core-notification';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import Table from './components/table';

const AdditionalServices = ({
  additionalServicesList,
  contentfulError,
  viewType,
  additionalServices,
  setAdditionalServices,
  total,
  setTotal
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    iotOrderDetailsSection: { additionalServicesHeading }
  } = localizedStrings;

  return (
    <>
      {contentfulError && (
        <Notification variant="error" copy="en">
          Error fetching additional services data from contentful
        </Notification>
      )}

      {!contentfulError && additionalServicesList.length > 0 && (
        <Box between={3}>
          <Heading level="h4">{additionalServicesHeading}</Heading>
          <Table
            viewType={viewType}
            additionalServices={additionalServices}
            setAdditionalServices={setAdditionalServices}
            list={additionalServicesList}
            total={total}
            setTotal={setTotal}
          />
        </Box>
      )}
    </>
  );
};

AdditionalServices.propTypes = {
  additionalServicesList: PropTypes.objectOf(PropTypes.any).isRequired,
  contentfulError: PropTypes.objectOf(PropTypes.any).isRequired,
  viewType: PropTypes.string.isRequired,
  additionalServices: PropTypes.arrayOf(PropTypes.object).isRequired,
  setAdditionalServices: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  setTotal: PropTypes.func.isRequired
};

export default AdditionalServices;
